import { createSlice } from "@reduxjs/toolkit";
import { getCompliance } from "../reduxApi/complianceReduxApi";

const complianceSlice = createSlice({
  name: "compliance",
  initialState: {
    status: "idel",
    compliance: [],
  },
  reducers: {
    deleteComplianceAction: (state, action) => {
      action.payload.forEach((ROWID) => {
          const index = state.compliance.findIndex((item) => item.ROWID === ROWID);
          if (index !== -1) {
              state.compliance.splice(index, 1);
          }
      });
  },
    updateComplianceAction: (state, action) => {
      console.log("action", action.payload.ROWID);
      const index = state.compliance.findIndex(
        (item) => item.ROWID === action.payload.ROWID
      );
      if (index != -1) {
        state.compliance.splice(index, 1, action.payload);
      }
    },
    addcomplianceAction: (state, action) => {
      console.log("Adding compliance:", action.payload);
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID;
      state.compliance.unshift(temp);
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getCompliance.pending, (state, action) => {
        state.status = "pending";
      })
      .addCase(getCompliance.fulfilled, (state, action) => {
        state.status = "fulfilled";
        console.log("testing compliance Data", action.payload);
        state.compliance = action.payload.data.complianceResp;
      });
  },
});
export const {
  deleteComplianceAction,
  updateComplianceAction,
  addcomplianceAction,
} = complianceSlice.actions;
export default complianceSlice.reducer;
